import React, { useEffect } from 'react';
import Highcharts      from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';

function createArrayWithLength(sexPartners, comparisonValue) {
    // Create a new array with all elements set to 0
    let newArray = Array(sexPartners).fill(0);
    // Set the last element to the length of the array
    newArray[sexPartners] = comparisonValue;
    return newArray;
}

const arrayX = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99];

const Chart = ({ comparisonValue, sexPartners, percentageArray, gender }) => {

    let YourData = createArrayWithLength(sexPartners * 1, comparisonValue * 1);
    // console.log('New Array =', YourData);
    
    useEffect(() => {
        const options = {
            chart: {
                type: 'column'
            },
            title: {
                text: `Distribution of number of sex partners for ${gender}s age`,
                align: 'center'
            },
            subtitle: {
                text:
                    '',
                align: 'left'
            },
            xAxis: {
                categories: arrayX, // arrayX
                crosshair: true,
                accessibility: {
                    description: ''
                }
            },
            yAxis: {
                min: 0,
                max: 30,
                title: {
                    text: '% of respondents'
                }
            },
            tooltip: {
                valueSuffix: '',
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    grouping: false,
                    shadow: false,
                }
            },
            series: [
                {
                    name: 'Number of Sexual Partners',
                    data: percentageArray,
                    color: 'grey',
                    tooltip: {
                        valuePrefix: '',
                        valueSuffix: ' % of respondents'
                    },

                },
                {
                    name: ``,
                    data: YourData, // Show Your value on a graphic
                    color: '#ff4d54',
                    tooltip: {
                        valuePrefix: '',
                        valueSuffix: ' % of respondents'
                    },
                }
            ]
        };

        Highcharts.chart('chart-container', options);
    }, []);

    return <div id="chart-container"></div>;
};

export default Chart;